import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getNotificationsUser } from '../actions/notificationActions';
import { Link } from 'react-router-dom';

export const HomeScreen = () => {

  const dispatch = useDispatch();

  const userSignin = useSelector(state => state.userSignin)
  const {userInfo} = userSignin;
  
  const {profile, menu} = useSelector(state => state.navigation);


  useEffect(() => {
    if (userInfo) {
      dispatch(getNotificationsUser());
    }
    
  }, [dispatch, userInfo])
  return (
    <>
      <style>{`body {background-image: none !important}`}</style>
      <div id="home-container">
        <div className='row text-center text-white mw-100'>
          <div className='col-12 p-0 mb-3'>
            <img src='/assets/media/logos/Grupo_188.png' alt='Logo de Compañía de María' className='home-logo' />
          </div>
          {
            profile === "user"
            ?
              <>
                <div className='col-12 mt-10 d-flex justify-content-center p-0'>
                  <h1 className='home-title text-white'>
                    Bienvenido/a a SD School+
                  </h1>
                </div>
                <div className='col-12 mt-2 d-flex justify-content-center p-0'>
                  <p className='fs-sm-1 home-paragraph'>
                    Le damos la bienvenida a nuestra plataforma. En nuestra continua intención de mejora ponemos a su disposición esta aplicación donde podrás:
                  </p>
                </div>
                <div className='col-12 mt-2 d-flex justify-content-center p-0'>
                    <ul className='home-list'>
                      <li>ADQUIRIR MATERIAL ESCOLAR</li>
                      <li>PAGAR ACTIVIDADES EXTRAESCOLARES</li>
                      <li>PAGAR COMEDOR</li>
                    </ul>
                </div>
              </>
            :
              menu === "store" && (userInfo.isAdmin|| userInfo.isConsultant)
              ?
                <>
                  <div className='col-12 mt-10 d-flex justify-content-center p-0'>
                    <h1 className='home-title text-white'>
                      Bienvenido/a tu tienda en SD School+
                    </h1>
                  </div>
                  <div className='col-12 mt-2 d-flex justify-content-center p-0'>
                    <p className='fs-sm-1 home-paragraph'>
                      Desde aquí podrás crear nuevos productos, añadir categorías, suscripciones y actividades extracolares
                    </p>
                  </div>
                  <div className='col-12 mt-2 d-flex justify-content-center p-0'>
                      <Link to="/product/new" className='btn btn-white text-info rounded-pill'>
                        <img src="/store.svg" alt="Tienda" className='me-2'/>
                        Crear producto
                      </Link>
                  </div>
                </>
              :
                userInfo.isAdmin || userInfo.isTeacher || userInfo.isStopbullying || userInfo.isSuperAdmin
                ?
                  <>
                    <div className='col-12 mt-10 d-flex justify-content-center p-0'>
                      <h1 className='home-title text-white'>
                        Bienvenido/a tu Colegio en SD School+
                      </h1>
                    </div>
                    <div className='col-12 mt-2 d-flex justify-content-center p-0'>
                      <p className='fs-sm-1 home-paragraph'>
                        Desde aquí podrás gestionar todos los temas relacionado con tu centro y alumnados
                      </p>
                    </div>
                    {
                      (userInfo.isAdmin || userInfo.isTeacher) &&
                      <div className='col-12 mt-2 d-flex justify-content-center p-0'>
                          <Link to="/courselist" className='btn btn-white text-light-red rounded-pill'>
                            <img src="/school.svg" alt="Tienda" className='me-2'/>
                            Gestionar Cursos
                          </Link>
                      </div>
                    }
                  </>
                :
                  <></>
          }
        </div>
      </div>
    </>

  )
}
